import { execute } from '@/api/execute'
import { GET, PUT, POST } from '@/api/types'
import { addQueryParams } from '@/util/index.js'

const ENDPOINT = 'manager/recipes'

export default {
  list (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/`, params))
  },

  litelist (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/list/`, params))
  },

  create (payload) {
    return execute(POST, `${ENDPOINT}/`, payload)
  },

  craft (payload) {
    return execute(POST, `${ENDPOINT}/craft/`, payload)
  },

  getById (id) {
    return execute(GET, `${ENDPOINT}/${id}/`)
  },

  updateById (id, payload) {
    return execute(PUT, `${ENDPOINT}/${id}/`, payload)
  }
}
